import { SxProps, Theme } from "@mui/material";

export default function CustomMuiScrollBar(): SxProps<Theme> {
  return {
    '&::-webkit-scrollbar': {
      width: '6px',
    },
    '&::-webkit-scrollbar-track': {
      background: 'var(--color-border)',
      borderRadius: '3px',
    },
    '&::-webkit-scrollbar-thumb': {
      background: 'var(--color-muted-foreground)',
      borderRadius: '3px',
      opacity: 0.6,
    },
    '&::-webkit-scrollbar-thumb:hover': {
      background: 'var(--color-foreground)',
      opacity: 0.8,
    },
  };
}